import React from 'react'
import './index.less'
import Overlay from './../../share/Overlay/index'

class InvestmentDialog extends React.Component {
    render () {
        const { InvestRecordList = [], handleShowRecord, investRecordTitle } = this.props
        return (
            <React.Fragment>
                <Overlay />
                <div className={'investRecord'}>
                    <p>
                        <span>{investRecordTitle}</span>
                        <i className={'closeIcon'} onClick={() => handleShowRecord()}/>
                    </p>
                    <ul>
                        {
                            InvestRecordList.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <p>
                                            <span>
                                                {item.bankName + '|' + item.productName}
                                            </span>
                                            <span>
                                                {item.productIncreaseRate ? (item.productRate + '%+' + item.productIncreaseRate +
                                                        '%(加息' + item.increaseTerm + '天)') : (item.productRate + '%')}
                                            </span>
                                        </p>
                                        <p>
                                            <span>
                                                {item.tradeAmount}元
                                            </span>
                                            <span>
                                                {item.tradeTime}
                                            </span>
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </React.Fragment>
        )
    }
}

export default InvestmentDialog
